import React, { useState, useContext } from 'react'
import IconArrow from '@jarvis.oddle/core/components/Icons/IconArrow'
import HorizontalDottedStepsBar from 'src/components/core/HorizontalDottedStepsBar'
import VerticalDottedStepsBar from 'src/components/core/VerticalDottedStepsBar'
import styled from 'styled-components'
import { H2, Text } from '@jarvis.oddle/core/components/Typo'
import Flex from '@jarvis.oddle/core/components/Flex'
import Div from '@jarvis.oddle/core/components/Div'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import Divider from '@jarvis.oddle/core/components/Divider'
import {
  deliverySteps,
  listOfDeliveryStatus,
  listOfPickupOrder,
  pickupSteps
} from 'src/components/molecules/NewOrderDetails/helper'

const StyledHeaderStatusOrder = styled(H2)`
  margin-top: 0;
  font-weight: 700;
  cursor: pointer;
  color: ${(props) => props.theme.colorHeadingsFont};
`

const StyledStatusOrder = styled(Flex)<{ isCenter: boolean }>`
  justify-content: ${(props) => (props.isCenter ? 'center' : 'space-between')};
  align-items: center;
`
const StyledIconArrow = styled(Div)`
  cursor: pointer;
`

interface MobileStatusOrderProps {
  orderStatusDescription: {
    header?: string
    description?: string
    status?: string
  }
  isPickup: boolean
  isHideContent: boolean
  loading?: boolean
}

const StyledDivider = styled(Divider)`
  margin-top: 20px;
  height: 1px;
`

const MobileStatusOrder = ({
  orderStatusDescription,
  isPickup,
  isHideContent,
  loading = false
}: MobileStatusOrderProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const [isCollapsable, setIscollapsable] = useState(loading)
  return (
    <>
      <StyledStatusOrder onClick={() => setIscollapsable(!isCollapsable)}>
        <StyledHeaderStatusOrder
          isCenter={isHideContent}
          data-testid='orderStatusButton'
        >
          {t(`${orderStatusDescription.header}`)}
        </StyledHeaderStatusOrder>
        {isHideContent && (
          <StyledIconArrow>
            <IconArrow
              iconSize='small'
              direction={isCollapsable ? 'up' : 'down'}
            />
          </StyledIconArrow>
        )}
      </StyledStatusOrder>
      {isCollapsable
        ? isHideContent && (
            <>
              <Flex>
                <Text data-testid='orderStatusText'>
                  {t(`${orderStatusDescription.description}`)}
                </Text>
                <VerticalDottedStepsBar
                  status={loading ? 'Loading' : orderStatusDescription.status}
                  listOfStatus={
                    isPickup ? listOfPickupOrder : listOfDeliveryStatus
                  }
                  steps={isPickup ? pickupSteps : deliverySteps}
                />
              </Flex>
            </>
          )
        : isHideContent && (
            <HorizontalDottedStepsBar
              step={5}
              status={loading ? 'Loading' : orderStatusDescription.status}
              steps={isPickup ? pickupSteps : deliverySteps}
            />
          )}
      <StyledDivider />
    </>
  )
}

export default MobileStatusOrder
